var map = {
	"./medal_1.svg": "O1wz",
	"./medal_2.svg": "IwNK",
	"./medal_3.svg": "EoCW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "K0in";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/medal_.*\.svg$
// module id = K0in
// module chunks = 0